import {
  DefaultFetchError,
  FetchCreate,
  useFetchCreate,
  FetchGetId,
  useFetchGetId,
} from "./fetch";

interface UploadFileSuccess {
  id: string;
  originalName: string;
  url?: string;
}

export const useUploadFile = (
  uploadUrl = "files/upload",
  authorization = true,
): FetchCreate<UploadFileSuccess, DefaultFetchError, FormData> =>
  useFetchCreate(uploadUrl, {
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
    authorization,
  });

export const useDownloadFile = (
  abortController: AbortController,
): FetchGetId<ArrayBuffer> =>
  useFetchGetId(
    "files",
    "",
    {
      autoStart: false,
      startStateLoading: false,
      config: {
        headers: { "content-type": "multipart/form-data" },
        signal: abortController.signal,
      },
    },
    "arraybuffer",
  );

export default {
  useUploadFile,
};
